import { Inject } from '@odinjs/odin';

import { Endpoint, ReportService } from '@philips-emr/hpms-stipulator-commons';
import { ButtonAPI, DynamicFieldsAPI, FieldAPI, FormAPI, Metadata, PanelAPI } from '@philips-emr/tws-components';
import { Value } from '@philips-emr/tws-core';
import Controller, { OnChange, OnClick, OnMount } from '@philips-emr/tws-core/lib/client';
import { ChangeEvent } from '@philips-emr/tws-core/lib/component/types';
import { HttpService } from '@philips-emr/tws-core/lib/services';
import { format } from '@philips-emr/tws-core/lib/services/model-service';
import { applicationContext } from '@philips-emr/tws-foundation';

import BaseController from './BaseController';

interface Relatorio {
  cdRelatorio: string;
  cdClassifRelat: string;
}

@Controller({ fragment: 'relatorios' })
class RelatoriosController extends BaseController {

  @Inject('field-relatorio')
  private field: FieldAPI;

  @Inject('button-gerar')
  private gerar: ButtonAPI;

  @Inject('dynamic-fields')
  private dynamicFields: DynamicFieldsAPI;

  @Inject('form-dynamic')
  private formDynamic: FormAPI;

  @Inject('panel-dynamic')
  private panel: PanelAPI;

  @OnMount('panel-1')
  onMount(): void{
    applicationContext.openModule('relatorios');
  }

  @OnClick({ target: ['button-gerar'] })
  onClickGerar(): void {
    if (this.panel.isVisible()) {
      this.formDynamic.submit();

      if (!this.formDynamic.isValid()) {
        return;
      }
    }

    const relatorio = this.field.getValue() as Relatorio;
    this.gerar.setEnabled(false);
    const reportService = new ReportService('13', '');

    const params = this.getParams();
    reportService.gerarRelatorio(relatorio.cdRelatorio, relatorio.cdClassifRelat, params)
      .finally(() => {
        this.formDynamic.setEditing(true);
        this.formDynamic.setLocked(false);
        this.gerar.setEnabled(true);
      });
  }

  @OnChange({ target: ['field-relatorio'] })
  onChangeRelatorio(e: ChangeEvent<Record<string, Value>>): void {

    if (!e.value) {
      this.formDynamic.setRecord({});
      this.panel.setVisible(false);
      this.gerar.setEnabled(false);
      return;
    }

    this.gerar.setEnabled(!!e.value.nrSequencia && e.value.nrSequencia !== '');
    const nrSeqRelatorio = e.value.nrSequencia as string;

    HttpService.get(Endpoint.GET.PARAMETROS_DINAMICOS, { nrSeqRelatorio })
      .then(resp => {
        const metadata = resp.body as Metadata;
        if (metadata) {
          this.panel.setVisible(true);
          this.formDynamic.setRecord({});
          this.dynamicFields.setMetadata(resp.body as Metadata);
        } else {
          this.panel.setVisible(false);
        }
      })
      .catch(() => {
        this.panel.setVisible(false);
      });
  }

  private getParams(): {} {
    let params = {};

    if (this.panel.isVisible()) {
      const record = this.formDynamic.getRecord();
      Object.keys(record).forEach(k => {
        if (record[k]) {
          if (typeof record[k] === 'object') {
            const value = record[k] as Record<string, Value>;
            params = { ...params, [k]: value.value, DYNAMIC: true };
          } else {
            const value = format('date', record[k]);
            params = { ...params, [k]: value, DYNAMIC: true };
          }
        }
      });
    }

    return params;
  }
}

export default RelatoriosController;
